import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Pagination } from '../models/pagination';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from '../models/api-response';
import { List } from '../models/list';
import { Software } from '../models/software';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SoftwareService {

  endpoint: string;

  constructor(private baseService: BaseService) {
    this.endpoint = 'softwares';
  }

  public getAll(productId: string, pagination?: Pagination): Observable<ApiResponse<List<Software>>> {
    return this.baseService.getAll<List<Software>>(this.endpoint, { params: Object.assign({}, pagination, !!productId ? { productId: productId } : {}) })
    .pipe(map(data => {
      data.payload.elements.forEach(e => {
        if (!e.id) {
          e.id = e._id;
          delete e._id;
        }
      });
      return data;
    }));
  }

  public get(id: string): Observable<ApiResponse<Software>> {
    return this.baseService.get<Software>(`${this.endpoint}/${id}`);
  }

  public add(software: Software): Observable<ApiResponse<Software>> {
    return this.baseService.add<Software>(this.endpoint, this.prepareFormData(software), this.prepareFormDataHeaders());
  }

  public update(id: string, software: Software): Observable<ApiResponse<Software>> {
    return this.baseService.update<Software>(`${this.endpoint}/${id}`, this.prepareFormData(software), this.prepareFormDataHeaders());
  }

  public delete(id: string): Observable<ApiResponse<Software>> {
    return this.baseService.delete<Software>(`${this.endpoint}/${id}`);
  }

  private prepareFormData(software: Software) {
    let formData: FormData = new FormData();
    Object.keys(software).forEach(k => {
      if (k === ' icon' || k === 'softwarePackage' && software[k] !== null) {
        formData.append(k, software[k], software[k].name);
      } else {
        formData.append(k, software[k]);
      }
    });
    return formData;
  }

  private prepareFormDataHeaders() {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    return headers;
  }

}
